export default __webpack_public_path__ + "static/media/macao.08a7d385.mp3";